import { HttpParams } from "@angular/common/http";
import { Component, Inject, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from "@angular/material/dialog";
import { environment } from "src/environments/environment";
import { AuthService } from "../../core/services/auth/auth.service";
import { LoginUser } from "../../core/data/models/login-user";
import { CommonConfirmDialogComponent } from "../common-confirm-dialog/common-confirm-dialog.component";
import { GetLoginUserResponse } from "../../core/data/models/get-login-user-response";
import { UserConfirmDialogInfo } from "../../core/data/models/user-confirm-dialog-info";
import { GetUserWithSitesLinksInfo } from "../../core/data/models/get-user-with-sites-links-info";
import { Const } from "../../core/data/models/const";
import { CognitoApi } from "src/app/core/api/cognito.api";
import { UsersApi } from "src/app/core/api/users.api";

@Component({
  selector: "app-user-delete-dialog",
  templateUrl: "./user-delete-dialog.component.html",
  styleUrls: ["./user-delete-dialog.component.scss"],
})
export class UserDeleteDialogComponent implements OnInit {
  getLoginUserResponse: GetLoginUserResponse;
  loginUser: LoginUser = Const.loginUser;

  constructor(
    @Inject(MAT_DIALOG_DATA) public user: GetUserWithSitesLinksInfo,

    public confirmDialog: MatDialog,
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<UserDeleteDialogComponent>,
    private router: Router,
    public auth: AuthService,

    private cognitoApi: CognitoApi,
    private usersApi: UsersApi
  ) {}

  ngOnInit() {
    this.loginUser = Const.loginUser;
  }

  // ユーザー削除
  onClickConfirm() {
    if (!navigator.onLine) {
      alert("ネットワーク接続を確認してください");
      return;
    }

    let message = "ユーザーを削除します。よろしいですか？";
    if (this.loginUser.id === this.user.id) {
      message = "自身を削除するとログイン出来なくなりますがよろしいですか？";
    }
    const messageInfo = new UserConfirmDialogInfo("ユーザー削除", message);
    const userConfirmDialogRef = this.confirmDialog.open(
      CommonConfirmDialogComponent,
      {
        width: "600px",
        data: messageInfo,
      }
    );

    userConfirmDialogRef.afterClosed().subscribe((result) => {
      if (result === "Yes") {
        this.deleteUser();
      }
    });
  }

  // Cognitoユーザーのステータスを無効化し、ユーザーを論理削除する。
  deleteUser() {
    try {
      // Cognitoユーザーのステータスを無効に変更
      let cognitoParams = new HttpParams();
      cognitoParams = cognitoParams.set(
        "user_pool_id",
        environment.amplify.Auth.aws_user_pools_id
      );
      cognitoParams = cognitoParams.set("user_name", this.user.loginId);

      this.cognitoApi
        .disableCognitoUser(cognitoParams)
        .subscribe((response: any) => {
          // ユーザー削除
          const params = new HttpParams();

          this.usersApi
            .deleteUser(this.user.id, params)
            .subscribe((responseb) => {});
          this.dialogRef.close("close");
        });
    } catch (error) {
      alert("ユーザー削除に失敗しました。");
    }
  }
}
